import { render, staticRenderFns } from "./template-1.vue?vue&type=template&id=fbff3de8&scoped=true"
import script from "./template-1.vue?vue&type=script&lang=js"
export * from "./template-1.vue?vue&type=script&lang=js"
import style0 from "./template-1.vue?vue&type=style&index=0&id=fbff3de8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbff3de8",
  null
  
)

export default component.exports